var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { attrs: { tag: "w-card-content" } },
    [
      _c(
        "w-row",
        [
          _c("w-col", { attrs: { xs: "12", md: "12" } }, [
            _vm._v(" " + _vm._s(_vm.$ct("info-date-previews")) + " "),
          ]),
          !_vm.errorMessage
            ? _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                _vm._l(_vm.readableDates, function (date) {
                  return _c("div", { key: date, staticClass: "date" }, [
                    _vm._v(" " + _vm._s(date) + " "),
                  ])
                }),
                0
              )
            : _c("w-col", { attrs: { xs: "12", md: "6" } }, [
                _c("div", { staticClass: "error" }, [
                  _vm._v(" " + _vm._s(_vm.errorMessage) + " "),
                ]),
              ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }